// extracted by mini-css-extract-plugin
export default {"container":"iOp0C","container--hidden":"BrAdp","content":"JVYcK","content--right":"oNkUC","texts":"fVTep","text":"kLRIr","actions":"wElaz","hidden":"pK4Z3"};